import Vec2 from 'vec2';

export type BoundingBox = {
  left: number;
  top: number;
  right: number;
  bottom: number;
};

export const createBoundingBox = (
  left = 0,
  top = 0,
  right = 0,
  bottom = 0
): BoundingBox => ({ left, top, right, bottom });

export const getAbsoluteCenter = (boundingBox: BoundingBox): Vec2 =>
  new Vec2(
    (boundingBox.left + boundingBox.right) / 2,
    (boundingBox.bottom + boundingBox.top) / 2
  );

export const getMidPoint = (boundingBox: BoundingBox): Vec2 =>
  new Vec2(getWidth(boundingBox) / 2, getHeight(boundingBox) / 2);

export const getWidth = (boundingBox: BoundingBox): number =>
  Math.abs(boundingBox.right - boundingBox.left);

export const getHeight = (boundingBox: BoundingBox): number =>
  Math.abs(boundingBox.top - boundingBox.bottom);

export const boundingBoxAsPointArray = (boundingBox: BoundingBox): Vec2[] => [
  new Vec2(boundingBox.left, boundingBox.top),
  new Vec2(boundingBox.right, boundingBox.top),
  new Vec2(boundingBox.right, boundingBox.bottom),
  new Vec2(boundingBox.left, boundingBox.bottom),
];
